{
  "general": {
    "title": "Compare Options",
    "intro": "A quick look at the difference between Community, Subscription and One-Time Purchase.",
    "tableheader": "Subscription",
    "note1": "* Group purchase options and volume discount available.",
    "note2": "** Languages supported Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Requires a free myboardmaker.com community account and is intended for activities storage only."
  },
  "columnHeadings": {
    "community": "COMMUNITY",
    "onetime": "ONE-TIME PURCHASE*",
    "personal": "PERSONAL",
    "professional": "PROFESSIONAL",
    "organization": "ORGANIZATION*"
  },
  "mobileHeadings": {
    "community": "Community",
    "onetime": "One-Time Purchase*",
    "personal": "Personal",
    "professional": "Professional",
    "organization": "Organization*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Activations",
    "languages": "Languages**",
    "licensing": "Licensing",
    "pcsSymbols": "PCS Symbols",
    "templates": "Templates",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Play Activities as Instructor",
    "playActivitiesStudent": "Play Activities as Student",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Instructor Management",
    "studentManagement": "Student Management",
    "assignStudentActivities": "Assign Student Activities",
    "cloudStorage": "Cloud Storage",
    "createAndJoin": "Create and Join Groups",
    "accessCommunity": "Access to 120k+ Community Activities",
    "shareActivity": "Share Activities in Community",
    "curriculum": "Curriculum & Content",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Premium Activities",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 Devices",
    "unlimited": "Unlimited",
    "byKey": "License Key",
    "symbols": "80,000+",
    "templates": "600+",
    "languages": "12",
    "login": "Login",
    "yes": "Yes",
    "yesNote": "Yes***",
    "no": "No"
  }
}
